import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';

function RetourButton() {
  const navigate = useNavigate();

  const handleRetour = () => {
    navigate(-1); // -1 signifie "page précédente"
  };

  return (
    <button
      onClick={handleRetour}
      className="flex items-center justify-center gap-2 px-4 py-2 bg-lightRedCustom hover:bg-redCustom text-white text-sm font-medium rounded-full shadow-lg hover:shadow-xl transition-all duration-300 animate-fadeIn"
    >
      <FontAwesomeIcon icon={faArrowLeft} />
      Retour
    </button>
  );
}

export default RetourButton;